import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { loadBamboohealthCheck } from '../../actions/med-review.actions';
import { BamboohealthDataModel } from '../../models/bamboohealth-data.model';
import { selectBamboohealthData } from '../../selectors/med-review.selectors';

export interface BambooHealthDialogData {
  medReviewId: number;
  bambooHealthData?: BamboohealthDataModel[];
  remainingNarxScores:[];
}

@Component({
  selector: 'kt-bamboo-health-data',
  templateUrl: './bamboo-health-data.component.html',
  styleUrls: ['./bamboo-health-data.component.scss'],
})
export class BambooHealthDataComponent implements OnInit{
  reportTriggered = false;
  constructor(
    public dialogRef: MatDialogRef<BambooHealthDataComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
    private store: Store,
  ) {}

  bambooData = this.dialogData?.bambooHealthData?.engineResults[0];
  remainingNarxScores;
  isSkipped = false;
  checkFailed = false;
  errorMessage;
  bambooHealthData$;
  ngOnInit() {
    this.remainingNarxScores = this.dialogData?.remainingNarxScores || [];
    this.store.select(selectBamboohealthData).subscribe(
      (value) => {this.bambooHealthData$ = value;
        this.reportTriggered = false;
      }
    );

    if (this.bambooData.status === 'FAILURE' || this.bambooData.status === 'TIMEOUT') {
      this.checkFailed = true;
      this.errorMessage = 'The PMP could not be reached. Please try again or contact support';
    } else if (this.bambooData.status === 'SKIPPED') {
      this.errorMessage =
        "This patient'srecord is missing the name or date of birth needed for a PMP check";
      this.isSkipped = true;
      this.checkFailed = true;
    } else {
      this.errorMessage = this.bambooData?.errorMessage;
    }
  }
  close(): void {
    this.dialogRef.close();
  }
  showNarxCareReport() {
    this.reportTriggered = true;
    if (this.bambooHealthData$?.engineResults[0]?.riskScore?.viewableReportUrl)
      window.open(this.bambooHealthData$?.engineResults[0]?.riskScore?.viewableReportUrl, '_blank');
  }
  RefreshScore() {
    this.store.dispatch(
      loadBamboohealthCheck({
        triggerType: 'MANUAL_REQUEST',
        medReviewId: this.dialogData.medReviewId,
      }),
    );
  }
}
